<template>
  <div class="price">
    <v-app style="width: 0">
      <vmodal
        :dialog="is_rates_modal_visible"
        :width="popup_width"
        :class="{ is_modal_success: rates_modal_stage !== 'start' }"
        @close="toggle_rates_modal(false)"
      >
        <div slot="title" class="header-title">
          <h3 v-if="rates_modal_stage === 'start'">{{ $tr('price.popup.title') }}</h3>
          <div class="close-icon">
            <i class="icon icon-close" @click="toggle_rates_modal(false)"></i>
          </div>
        </div>

        <div id="modal-body" slot="body">
          <div v-if="rates_modal_stage === 'start'" class="modal-start">
            <div v-for="(block, i) in blocks" :key="i" class="block">
              <template v-if="block.id !== 'sms' || is_sms_enabled">
                <div class="block__title">{{ $tr(`price.popup.block.title_${block.id}`) }}</div>
                <div class="block__wrap">
                  <div class="block__text">{{ $tr(`price.popup.block.text_${block.id}`) }}</div>
                  <vinput
                    :id="block.id"
                    class="block__input"
                    :value="block.value"
                    valuetype="number"
                    :border="true"
                    :center="true"
                    @input="set_input($event, block.id)"
                  />
                </div>
              </template>
            </div>

            <div class="block block-modules">
              <div class="block__title">{{ $tr(`price.popup.block.title_moduls`) }}</div>
              <div class="block__wrap">
                <div class="block__text">{{ $tr(`price.popup.block.text_moduls`) }}</div>
                <div class="block-modules__check">
                  <vchecklabel
                    v-for="item in filteredModules"
                    :key="item.id"
                    class="check"
                    :value="modules_selected.indexOf(item.id) > -1"
                    :label="item.name"
                    :mini="true"
                    @input="set_selected_ids($event, item)"
                  />
                </div>
              </div>
            </div>

            <div class="block block-time">
              <div class="block__title">{{ $tr(`price.popup.block.title_time`) }}</div>
              <div class="block__wrap">
                <div class="block__text">{{ $tr(`price.popup.block.text_time`) }}</div>
                <div class="tab">
                  <div
                    v-for="(item, i) in time"
                    :key="i"
                    :class="['tab__item', { active: item.id === time_id }]"
                    @click="set_time(item.id)"
                    v-html="item.name"
                  ></div>
                </div>
              </div>
            </div>
          </div>

          <div v-else class="modal-success">
            <img src="/static/images/elements/icon_big_ok_neww.png" />
            <p v-html="$tr('price.popup.success.text')"></p>
            <vbutton class="success-btn" label="common.ok" @click="toggle_rates_modal(false)" />
          </div>
        </div>

        <div slot="footer">
          <div class="footer">
            <div v-if="rates_modal_stage === 'start'">
              <div class="footer__text">{{ $tr(`price.popup.block.text_footer`) }}</div>
              <vbutton
                class="footer__button"
                label="price.popup.block.btn_footer"
                :loading="loading"
                :disabled="disabled || loading"
                @click="submit"
              />
            </div>
          </div>
        </div>
      </vmodal>
    </v-app>
  </div>
</template>

<script>
import axios from 'axios';
import { mapState } from 'vuex';

export default {
  name: 'PriceInfo',

  props: {
    is_rates_modal_visible: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      loading: false,
      rates_modal_stage: 'start',
      modules: [
        {
          name: $tr('vacancy.preferences.settings.application'),
          id: 'application'
        },
        {
          name: $tr('interview.landing.modules.test.title'),
          id: 'test'
        },
        {
          name: $tr('price.popup.dropout'),
          id: 'test-dropout'
        },
        {
          name: $tr('price.popup.sms'),
          id: 'sms'
        },
        {
          name: $tr('price.popup.emotions'),
          id: 'emotions'
        },
        {
          name: $tr('price.popup.online-interview'),
          id: 'online-interview'
        },
        {
          name: $tr('price.popup.anticheating'),
          id: 'anticheating'
        },
        {
          name: $tr('price.popup.ai-competence'),
          id: 'ai-competence'
        },
        {
          name: $tr('price.popup.survey-screening'),
          id: 'survey-screening'
        },
        {
          name: $tr('price.popup.speechToText'),
          id: 'speech_to_text'
        },
        {
          name: $tr('price.popup.pageCompany'),
          id: 'page'
        }
      ],

      time: [
        {
          name: $tr('price.popup.block.month1'),
          id: 1
        },
        {
          name: $tr('price.popup.block.month3'),
          id: 3
        },
        {
          name: $tr('price.popup.block.month6'),
          id: 6
        },
        {
          name: $tr('price.popup.block.month12'),
          id: 12
        }
      ],

      time_id: null,
      modules_selected: []
    };
  },

  computed: {
    ...mapState('company_new', ['rates']),

    filteredModules() {
      return this.modules.filter(item => {
        return item.id !== 'sms' || !this.is_sms_enabled;
      });
    },

    popup_width() {
      if (this.rates_modal_stage === 'start') {
        return 725;
      } else {
        return 650;
      }
    },

    response_balance() {
      return this.rates ? this.rates.response_balance + this.rates.monthly_response_balance + this.rates.extra_response_balance  : null;
    },

    vacancy_balance() {
      return this.rates ? this.rates.vacancies_count : null;
    },

    sms_balance() {
      return this.rates ? this.rates.sms_balance : null;
    },

    is_sms_enabled() {
      return this.rates ? this.rates.is_sms_enabled : false;
    },

    users_balance() {
      return this.rates ? this.rates.users_count : null;
    },

    blocks() {
      return this.$store.getters['company_new/price_blocks'];
    },

    response_count() {
      return this.blocks.find(el => el.id === 'responses').value;
    },

    vacancy_count() {
      return this.blocks.find(el => el.id === 'vacancies').value;
    },

    sms_count() {
      return this.blocks.find(el => el.id === 'sms').value;
    },

    users_count() {
      return this.blocks.find(el => el.id === 'users').value;
    },

    locale() {
      return this.$store.getters['locale/current'];
    },

    disabled() {
      return (
        !this.response_count &&
        !this.vacancy_count &&
        !this.users_count &&
        !this.modules_selected.length &&
        !this.time_id
      );
    }
  },

  beforeMount() {
    this.rates_modal_stage = 'start';
  },

  created() {
    if (this.vacancy_balance) {
      this.set_input(this.vacancy_balance, 'vacancies');
    }
    if (this.response_balance) {
      this.set_input(this.response_balance, 'responses');
    }
    if (this.users_balance) {
      this.set_input(this.users_balance, 'users');
    }
    if (this.sms_balance) {
      this.set_input(this.sms_balance, 'sms');
    }
  },

  methods: {
    toggle_rates_modal(val) {
      this.$emit('toggle_rates_modal', val);
    },

    set_selected_ids(v, item) {
      let result = [];

      if (v) {
        this.modules_selected.push(item.id);
      } else {
        let ind = this.modules_selected.indexOf(item.id);
        this.modules_selected.splice(ind, 1);
      }
      this.modules_selected.forEach(i => {
        result.push({ id: i });
      });
    },

    set_input(v, id_block) {
      this.$store.commit('company_new/set_value', {
        value: v,
        id: id_block
      });
    },

    set_time(id) {
      this.time_id = id;
    },

    submit() {
      this.loading = true;

      axios
        .post('/1.0/company-limits/tariff/request', {
          response_count: this.response_count,
          vacancy_count: this.vacancy_count,
          sms_count: this.sms_count,
          users_count: this.users_count,
          period: this.time_id,
          modules: this.modules_selected
        })
        .then(r => {
          this.loading = false;
          this.rates_modal_stage = 'success';
        })
        .catch(e => {
          this.$noty.error(this.$tr('common.error.text'));
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.price {
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 22px;

  .header-title {
    width: 100%;
    position: relative;

    h3 {
      font-weight: 500;
      font-size: 28px;
      line-height: 41px;
    }

    .close-icon {
      position: absolute;
      top: -14px;
      right: -8px;
      display: flex;
      cursor: pointer;

      i {
        color: #7f8b99;
        font-size: 28px;
      }
    }
  }

  .is_modal_success {
    .close-icon {
      top: -18px;
      right: -25px;
    }
  }

  .modal-start {
    .block {
      margin-bottom: 24px;

      &.block-modules {
        margin-bottom: -15px;
      }

      &__wrap {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
      }

      &__title {
        font-weight: 500;
        font-size: 18px;
        line-height: 26px;
        color: #233346;
        padding-bottom: 13px;
        border-bottom: 1px solid #d2d6e0;
        margin-bottom: 12px;
      }

      &__text {
        max-width: 280px;
        color: #9faab6;
        font-size: 15px;
        line-height: 22px;
        letter-spacing: 0.005em;
      }

      &__input {
        width: 40px;
        margin-top: 4px;
      }

      &-modules {
        &__check {
          width: 300px;
          margin-top: 2px;

          .check {
            float: left;
            margin-bottom: 0;
            height: 48px;
            align-items: flex-start;
            box-sizing: border-box;
            color: #233346;

            &:nth-child(even) {
              width: 55%;
              padding-left: 19px;
            }
            &:nth-child(odd) {
              width: 45%;
            }

            ::v-deep {
              .focus {
                margin-top: 2px;
              }
            }
          }
        }
      }

      &-time {
        margin-bottom: 31px;
        .tab {
          display: flex;
          margin-top: -1px;
          &__item {
            width: 50px;
            height: 50px;
            background: #ffffff;
            box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
            border-radius: 6px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            margin-left: 10px;
            font-size: 12px;
            line-height: 12px;
            letter-spacing: 0.005em;
            cursor: pointer;
            color: #233346;

            &.active {
              background: $green;
              color: #ffffff;
            }

            ::v-deepspan {
              display: block;
              font-size: 22px;
              line-height: 22px;
            }
          }
        }
      }
    }
  }

  .modal-success {
    text-align: center;

    img {
      margin: 16px auto 28px;
    }

    p {
      margin-bottom: 33px;
      color: #233346;
    }
    .success-btn {
      width: 80px;
    }
  }

  .footer {
    margin-left: -17px;
    color: #233346;
    &__text {
      text-align: center;
      margin-bottom: 22px;
    }

    &__button {
      display: block;
      margin: 0 auto;
    }
  }
}

.price ::v-deep {
  .vmodal-wrapper.is_modal_success .v-dialog > .v-card > .v-card__title,
  .vmodal-title {
    margin: 0;
  }
  .is_modal_success .v-dialog-card {
    padding: 38px 50px 54px 50px;
  }
  .vinput .input {
    padding: 10px 2px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 40px;
  }
}
</style>
